module.exports = __webpack_public_path__ + "static/media/sn.57ff71a4.svg";